<template>
	<v-dialog v-model="dialog" max-width="500px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="secondary" class="text-lowercase" icon v-on="on">
				<v-tooltip bottom color="primary">
					<template v-slot:activator="{ on }">
						<v-icon small v-on="on">mdi-lead-pencil</v-icon>
					</template>
					<span>{{'modify franchise' | localize}}</span>
				</v-tooltip>
			</v-btn>
		</template>
		<v-card v-show="!loading">
			<v-card-title class="subtitle-1 pt-6 text-pre-wrap">
				{{ 'Modify the parameters of the franchise' | localize }} <span class="secondary--text">{{ channel.name }}</span>
			</v-card-title>
			<v-card-text class="black--text">
				<v-container grid-list>
					<v-form v-model="valid" ref="form" lazy-validation>
						<v-row>
							<v-col cols="12" sm="6" md="6">
								<v-text-field
									color="secondary"
									:label="'Franchise cost' | localize"
									v-model.number="franchise_cost"
									name="franchiseCost"
									type="text"
									:rules="[rules.number]"
									@change="onceMore">
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="6">
								<v-text-field
									color="secondary"
									:label="'Franchise fee' | localize"
									v-model.number="franchise_fee"
									name="franchiseFee"
									type="text"
									:rules="[rules.number]"
									@change="onceMore">
								</v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-container>
				<v-row v-if="error" class="text-center mx-2 error--text">{{'Error' | localize }} => {{ error }}</v-row>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="secondary" text
					class="text-capitalize"
					:disabled="loading || Boolean(error) || !change"
					@click="changeChannel">
					{{ 'Save' | localize }}
				</v-btn>
				<v-btn color="secondary" text
					class="text-capitalize"
					@click="closeDialog">
					{{ 'Close' | localize }}
				</v-btn>
			</v-card-actions>
		</v-card>	
	</v-dialog>
</template>

<script>
import localizeFilter from '../../../filters/localize.filter';

	export default {
		props: ['channel'],
		data () {
			return	{
				dialog: false,
				valid: false,
				error: '',
				change: false,
				rules: {
					number: v => {
						if (!isNaN(parseFloat(v)) && v >= 0) return true;
						return localizeFilter('its expected number more than 0');
					}
				},
				//props
				franchise_cost: this.channel.franchise_cost,
				franchise_fee: this.channel.franchise_fee,
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading;
			},
			locale () {
				return this.$store.getters.locale;
			}
		},
		methods: {
			onceMore () {
				this.error = '';
				this.change = true;
			},
			async changeChannel () {

				if (this.$refs.form.validate()) {
					
					if (this.channel.franchise_cost === this.franchise_cost &&
						this.channel.franchise_fee === this.franchise_fee) {
						return this.error = 'No parameters of the franchise have been changed'
					}

					const channel = {
						id:  this.channel.id, 
						franchise_cost: this.franchise_cost,
						franchise_fee: this.franchise_fee,
						investment_costs: 0,
						operational_costs: 0,
						stores: 0
					}
						
					try {
						//changeChannel 
						await this.$store.dispatch('editChannel', channel)
						this.closeDialog ()					
					}
					catch (error) {
						this.error = error.message
					}
				}
			},
			closeDialog () {
				//reset
				this.dialog = false;
				this.error = '';
				this.change = false;
			}
		},
	}
</script>
